import React from 'react';

export const ArrowShortDownSvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M19.707 8.293a1 1 0 0 0-1.414 0L12 14.586 5.707 8.293a1 1 0 0 0-1.414 1.414l7 7a1 1 0 0 0 1.414 0l7-7a1 1 0 0 0 0-1.414"
            clipRule="evenodd"
        />
    </svg>
);
